import { Injectable } from '@angular/core';

import { DisplayDatePipe } from '@open-portal-app/core/pipes/display-date.pipe';
import { HERO_BANNER_SNAPSHOT } from '@open-portal-app/core/constants/policy.constants';

@Injectable({
  providedIn: 'root'
})
export class PolicyComponentService {
  constructor(
    private displayDatePipe: DisplayDatePipe,
  ) { }

  getSnapshot(policy: any) {
    let dynamicMarkup = '';
    switch(policy.productClass) {
      case 'travel':
        if (policy.coverType === 'multi') {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.travelMultiSnapshot(policy);
        } else {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.travelSnapshot(policy, this.displayDatePipe);
        }
        break;
      case 'mobile':
        break;
      case 'car':
        if (policy.paymentFrequency.key === 'M') {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.carMonthSnapshot(policy);
        } else {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.carSnapshot(policy);
        }
        break;
      case 'home':
        if (policy.paymentFrequency.key === 'M') {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.homeMonthSnapshot(policy);
        } else {
          dynamicMarkup = HERO_BANNER_SNAPSHOT.homeSnapshot(policy);
        }
        break;
      default:
    }
    return dynamicMarkup;
  }

  getBadgeDetails(policy: any) {
    let badgeDetails;

    if (policy.autoRenew) {
      badgeDetails = {
        label: "Auto renewal on",
        icon: "autorenew"
      }
    } else {
      badgeDetails = {
        label: "Auto renewal off",
        icon: "error_outline"
      }
    }

    return badgeDetails;
  }
}
